export default "__VITE_ASSET__DHMPmhE4__"